import { z } from "zod";

export const customerCareSchema = z.object({
    customer_care_phone_number: z.string().optional(),
});

export const gstSettingSchema = z.object({
    gstRate: z.number().min(0).max(100),
    priceUptoInclusive: z.number().min(0).nullable(),
});

export const companyDetailsSchema = z.object({
    companyName: z.string().optional(),
    godName: z.string().optional(),
    gstin: z.string().optional(),
    addressLine1: z.string().optional(),
    addressLine2: z.string().optional(),
    city: z.string().optional(),
    website: z.string().optional(),
    logo_url: z.string().optional(),
    phoneNumbers: z.array(z.string()).optional(),
});

export const generalSettingsFormValidation = z.object({
    gst_settings: z.array(gstSettingSchema),
    company_details: companyDetailsSchema,
    customer_care_phone_number: z.string().optional(),
});

export type IGeneralSettingsFormValues = z.infer<typeof generalSettingsFormValidation>;
export type ICompanyDetailsFormValues = z.infer<typeof companyDetailsSchema>;
export type IGstSettingsFormValues = z.infer<typeof gstSettingSchema>;
export type ICustomerCareFormValues = z.infer<typeof customerCareSchema>;